<template>
  <div class="cms-schema-form">
    <drawer-dialog-controls
      :is-loading="isLoading"
      :is-pristine="isPristine"
      :is-disabled="hasErrors"
      @close="$emit('close')"
      @save="onSave"
    >
      Schema for "{{ type.name }}"
      <template #actions>
        <v-chip v-if="currentVersion" small outlined color="primary" class="ml-2">
          v{{ currentVersion }}
        </v-chip>
      </template>
    </drawer-dialog-controls>

    <div class="form-content">
      <schema-constructor
        v-if="schemaLoaded"
        :value="schemaObject"
        @input="onSchemaChange"
        @errors="onSchemaErrors"
      />
      <div v-else class="text-center py-6">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import { API } from '@/utils/api'
import { DrawerDialogControls } from '@/components/core/DrawerDialog'
import SchemaConstructor from './schema-constructor/SchemaConstructor'

export default {
  components: {
    DrawerDialogControls,
    SchemaConstructor,
  },
  props: {
    type: Object,
    isLoading: Boolean,
  },
  data() {
    return {
      schemaObject: {},
      currentVersion: null,
      schemaLoaded: false,
      isPristine: true,
      schemaErrors: [],
    }
  },
  computed: {
    hasErrors() {
      return this.schemaErrors.length > 0
    },
  },
  mounted() {
    this.loadSchema()
  },
  methods: {
    loadSchema() {
      API.call('/cms/type-schema/get.json', {
        type_id: this.type.type_id,
        current_only: true,
        resolve: false,
      }).then(r => {
        if (r.data && r.data.item) {
          const raw = r.data.item.schema
          this.schemaObject = typeof raw === 'string' ? JSON.parse(raw) : (raw || {})
          this.currentVersion = r.data.item.version
        }
      }).catch(() => {
        this.schemaObject = {}
      }).finally(() => {
        this.schemaLoaded = true
        this.$nextTick(() => {
          this.isPristine = true
        })
      })
    },
    onSchemaChange(schema) {
      this.schemaObject = schema
      this.isPristine = false
    },
    onSchemaErrors(errors) {
      this.schemaErrors = errors
    },
    onSave() {
      this.$emit('save', {
        type_id: this.type.type_id,
        schema: JSON.stringify(this.schemaObject),
        is_current: true,
      })
    },
  },
}
</script>

<style scoped>
.cms-schema-form {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.form-content {
  background-color: #F2F2F2;
  padding: 1rem;
  flex: 1;
  overflow-y: auto;
}
</style>
